import { render, staticRenderFns } from "./ResetModal.vue?vue&type=template&id=93fffa26&scoped=true&"
import script from "./ResetModal.vue?vue&type=script&lang=js&"
export * from "./ResetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fffa26",
  null
  
)

export default component.exports